import type { JSX } from "react";
import { RouterProvider as TanStackRouterProvider } from "@tanstack/react-router";
import { router } from "@/routes/-router";

export function RouterProvider(): JSX.Element {
  return <TanStackRouterProvider router={router} />;
}
